import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { isUndefined } from 'lodash';
import { StaticContext } from 'react-router';

import { setAfterLoginRoutes, SUBSCRIPTION_EXPIRY_ALLOWED_ROUTES } from 'config/config';
import { CustomRouteProps } from 'common/models/navigationModel';
import { UserPaths } from 'features/user/models/userModel';

import { FullPageSpinner } from './FullPageSpinner';
import { ContentMenu } from './ContentMenu';
import { EditPaths, SupplierEditPaths } from 'features/edit/models/editModel';

export type RouteProps = RouteComponentProps<
    {
        [x: string]: string | undefined;
    },
    StaticContext,
    unknown
>;

export const CustomRoute = ({
    component: Component,
    isAuthenticated,
    isTokenChecked,
    redirect = '/sign-in',
    secured = false,
    path,
    activeOrganisation,
    isSubscriptionExpired,
    adminMenuLinks,
    contractManagerMenuLinks,
    menuLinks,
    exact,
    location,
    hideNavigation,
    SubNavigation,
    isUserAdmin,
    isUserTenant,
}: CustomRouteProps) => {
    const allowedRoutes = [...SUBSCRIPTION_EXPIRY_ALLOWED_ROUTES];

    if (activeOrganisation) {
        setAfterLoginRoutes(activeOrganisation.organisation.id);
    }
    const renderRouteContent = (routeProps: RouteProps) => {
        if (!Component) {
            return;
        }

        if (!isTokenChecked) {
            return <FullPageSpinner />;
        }

        if (isSubscriptionExpired) {
            if (isUserAdmin) {
                allowedRoutes.push(
                    isUserTenant ? EditPaths.Subscriptions : SupplierEditPaths.Users,
                );
            }
            const isRouteAllowed = allowedRoutes.some(
                (allowedRoute) => path && path.startsWith(allowedRoute),
            );

            let redirectPath = UserPaths.EditProfile;
            if (isUserAdmin) {
                redirectPath = isUserTenant ? EditPaths.Subscriptions : SupplierEditPaths.Users;
            }
            if (!isRouteAllowed) {
                return (
                    <Redirect
                        to={{
                            pathname: redirectPath,
                            state: { referrer: location },
                        }}
                    />
                );
            }
        }

        if (isAuthenticated === secured) {
            return isAuthenticated && isUndefined(activeOrganisation) ? (
                <FullPageSpinner />
            ) : (
                <>
                    {!hideNavigation && (
                        <ContentMenu
                            adminMenuLinks={adminMenuLinks}
                            contractManagerMenuLinks={contractManagerMenuLinks}
                            menuLinks={menuLinks}
                        />
                    )}
                    {SubNavigation && <SubNavigation {...routeProps} />}
                    <Component {...routeProps} />
                </>
            );
        }

        if (path == UserPaths.VerifyNewAccount || path == UserPaths.VerifyNewExecutive) {
            return <Component {...routeProps} />;
        }

        return (
            <Redirect
                to={{
                    pathname: redirect,
                    state: { state: 'Access denied', referrer: location },
                }}
            />
        );
    };

    return <Route path={path} exact={exact} render={renderRouteContent} />;
};
